import React, { useCallback } from 'react'
import { setLogout} from '../store/loginSlice'
import { useDispatch } from 'react-redux';
import { resetMain } from '../store/tagSlice';
import { useNavigate } from 'react-router-dom';
function NotFoundPage() {
    const navi = useNavigate();   
    const dispatch = useDispatch();
    const logout = useCallback(() => {
        navi('/Login');
        localStorage.removeItem('xqy_mainTag');
        localStorage.removeItem('xqy_mainTagActive');        
        dispatch(setLogout());    
        dispatch(resetMain()); 
    },[dispatch, navi]);    

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            textAlign: 'center'
        }}>
            <div>
                <h1>页面出错了...</h1>
                <a 
                    onClick={logout} 
                    style={{ 
                        cursor: 'pointer',
                        color: '#1890ff', // 可选：添加链接颜色
                        textDecoration: 'underline' // 可选：添加下划线
                    }}
                >
                    点击重新登录
                </a>
            </div>
        </div>
    );
}
export default NotFoundPage
// 在路由配置中使用